import { useState } from 'react';

interface ICustomSourceIdProps {
  onChangeCustomId: (id: string) => void;
}

export const CustomSourceIdField = ({ onChangeCustomId }: ICustomSourceIdProps) => {
  const [useCustomSource, setUseCustomSource] = useState(false);
  const [sourceAccountId, setSourceAccountId] = useState('UAT_SANDBOX');
  const [isApplied, setIsApplied] = useState(false);

  const handleApply = () => {
    onChangeCustomId(sourceAccountId);
    setIsApplied(true);
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSourceAccountId(e.target.value);
    if (isApplied) setIsApplied(false);
  };

  const isButtonDisabled = !useCustomSource || !sourceAccountId.trim() || isApplied;

  return (
    <div className='mt-2 space-y-2'>
      <label className='inline-flex cursor-pointer items-center'>
        <input
          type='checkbox'
          className='peer sr-only'
          checked={useCustomSource}
          onChange={(e) => setUseCustomSource(e.target.checked)}
        />
        <span className='text-slate-700 text-sm font-medium'>Custom Source Account ID</span>
        <div className='peer-checked:bg-blue-600 relative ml-2 h-4 w-8 rounded-full bg-gray-200 after:absolute after:left-[1px] after:top-[1px] after:h-3.5 after:w-3.5 after:rounded-full after:border after:border-gray-300 after:bg-white after:transition-all peer-checked:after:translate-x-4 peer-focus:ring-2 peer-focus:ring-gray-300' />
      </label>

      <input
        id='source-account-input'
        type='text'
        value={sourceAccountId}
        onChange={handleInputChange}
        disabled={!useCustomSource}
        placeholder='Custom Source Account ID'
        className='border-slate-300 text-slate-700 block w-full rounded-md border bg-white p-2 text-sm disabled:opacity-50'
      />

      <div className='flex justify-end'>
        <button
          onClick={handleApply}
          disabled={isButtonDisabled}
          className={`inline-flex items-center rounded-md px-4 py-2 text-sm font-medium transition ${isButtonDisabled
            ? 'cursor-not-allowed bg-gray-300 text-gray-500'
            : 'bg-blue-600 hover:bg-blue-700 text-white'
            } `}>
          Update
          {isApplied && (
            <svg
              xmlns='http://www.w3.org/2000/svg'
              className='text-green-500 ml-2 h-5 w-5'
              fill='none'
              viewBox='0 0 24 24'
              stroke='currentColor'
              strokeWidth={2}>
              <path strokeLinecap='round' strokeLinejoin='round' d='M5 13l4 4L19 7' />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
};
